// Post-type classification for the monthly posts view (feature 007-monthly-posts-view).
// Pure, typed, no React. Derives a coarse presentational post type from an activity's
// mode code, falling back to media/platform inspection when the mode is absent.
import {PeerActivityType} from "../../redux/Content/PeerActivity/types";
import {resolveMediaPreview} from "./WeekPostCard.helpers";

export type PostType = 'post' | 'reel' | 'story' | 'video';

// `handler` (platform code) is attached to calendar events at runtime but is not on PeerActivityType.
type ActivityWithHandler = PeerActivityType & { handler?: { code?: string; name?: string } };

// YouTube is keyed as 'youtube' by connectorHandlerCode (see getHandlerIconByCode); match loosely.
function isYouTube(handlerCode: string | undefined): boolean {
    const code = (handlerCode || "").toLowerCase();
    return code.includes("youtube") || code.includes("yt");
}

export function resolvePostType(activity: PeerActivityType): PostType {
    const modeCode = activity.mode?.code || "";

    switch (modeCode) {
        case "story":
            return "story";
        case "shorts":
            return "reel";
        case "post":
        case "bio":
        case "stat":
            return "post";
        default:
            break;
    }

    // Mode absent/empty → derive from media and platform.
    const hasVideo = resolveMediaPreview(activity).isVideo;
    if (hasVideo) {
        const handlerCode = (activity as ActivityWithHandler).handler?.code;
        return isYouTube(handlerCode) ? "video" : "reel";
    }
    return "post";
}
